import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';



const LostAndFound = () => {

    const [selectedImage, setSelectedImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const { t } = useTranslation();




    return (

        <>
            <Helmet>
                <title>{t('breed.meta_title')}</title>
                <meta name="description" content={t('lostandfound.meta_description')} />
                <meta name="keywords" content={t('lostandfound.meta_keywords')} />
            </Helmet>

            <Container>
                <Row>
                    <Col md={6} className="p-4">
                        <h1 className="my-4">{t('Lost & Found Pets: Report & Reunite with Our App')} </h1>
                        <p className="text-muted">{t('Lost a pet or found one? Quickly report it on the Pets Home App and notify nearby users to help bring them home.')}</p>
                        {/* <div className="center text-center">
                            <img
                                style={{ maxWidth: '300px', height: 'auto' }}
                                className="img-fluid rounded mb-4 center"
                                src="/assets/web/pets-lostandfound.png"
                                alt="Pet Lost and Found | Find Loving Homes for Dogs, Cats, and More | Pets Home App"
                            />

                        </div> */}

                        <p className="">{t('global.experince')}</p>
                        <p className='text-center font-weight-bold text-uppercase'>{t('global.h5_dwonload')}</p>
                        <div className="d-flex justify-content-center">
                            <a style={{ width: '130px', height: 'auto', marginRight: "10px" }} href="https://play.google.com/store/apps/details?id=com.app.petshome" target="_blank" rel="noopener noreferrer" className="mr-3"><img src="/google-play-badge.svg" alt="Google Play" /></a>
                            <a style={{ width: '130px', height: 'auto' }} href="https://apps.apple.com/us/app/pets-home-app/id1549828591?pt=581834&ct=desktop&mt=8" target="_blank" rel="noopener noreferrer"><img src="/app-store-badge.svg" alt="App Store" /></a>
                        </div>

                        <div className="d-flex justify-content-center">
                            <img style={{ width: '130px', height: 'auto', marginRight: "10px" }} src="/android-adobe-express-qr-code.png" alt="Android QR Code" className="mr-3" />
                            <img style={{ width: '130px', height: 'auto' }} src="/ios-express-qr-code.png" alt="iOS QR Code" />
                        </div>
                        <p className="text-center mt-3">{t('global.qr_code_p')} </p>
                    </Col>

                    <Col md={6} className="p-4 center text-center">




                        <img
                            style={{ maxWidth: '300px', height: 'auto' }}
                            className="img-fluid rounded mb-4 center"
                            src="/assets/web/pets-lostandfound.png"
                            alt="Pet Lost and Found |  Find Loving Homes for Dogs, Cats, and More | Pets Home App"
                        />
                    </Col>
                </Row>


                <Row className="mt-5">
                    <Col md={12}>
                        <h2 className="text-center mb-4">Reuniting Lost Pets With Their Families</h2>
                        <p>Welcome to Pets Home's Lost and Found service – your community resource for reconnecting lost pets with their worried families across the United States. Every day, countless beloved companions go missing, leaving pet owners desperate for help and guidance. Our platform provides the tools and support needed during these stressful times.</p>
                    </Col>
                </Row>

                <Row className="my-4">
                    <Col md={6}>
                        <h3>What To Do If Your Pet Is Missing</h3>
                        <p>The first 24 hours after your pet goes missing are critical. Studies show that <strong>70% of lost cats are found within a one-mile radius of their home</strong>, while dogs may travel further but often follow predictable patterns.</p>

                        <h4>Immediate Steps:</h4>
                        <ul>
                            <li>Search your home thoroughly - indoor cats especially may be hiding in small spaces</li>
                            <li>Canvas your neighborhood, especially at dawn and dusk when animals are most active</li>
                            <li>Create a detailed report on our app with clear photos and distinctive markings</li>
                            <li>Place familiar items like bedding or litter boxes outside your home</li>
                            <li>Contact nearby animal shelters and veterinary clinics</li>
                        </ul>

                        <h4>For Indoor Cats Missing Over 24 Hours:</h4>
                        <p>Don't lose hope! Indoor cats often hide close to home when scared. They typically travel less than 500 feet from their residence and may not respond even when called by their owners due to fear. Continue searching with flashlights at night, checking under porches, in garages, and dense vegetation.</p>
                    </Col>
                    <Col md={6}>
                        <h3>Found a Stray Animal?</h3>
                        <p>If you've encountered a lost pet, your compassion can be the bridge that reunites them with their family. Here's how to help:</p>

                        <h4>Safe Approach:</h4>
                        <ul>
                            <li>Approach slowly and calmly, avoiding direct eye contact which can appear threatening</li>
                            <li>If the animal seems frightened, don't chase - this may cause them to run further from home</li>
                            <li>Contact local animal control for assistance with scared or aggressive animals</li>
                            <li>Check for ID tags, collars, or microchip information</li>
                            <li>Post a "Found Pet" report on our app with photos and location details</li>
                        </ul>

                        <h4>Temporary Care:</h4>
                        <p>If you're able to safely contain the animal while searching for their owner, provide a quiet space, fresh water, and appropriate food. Keep found pets separated from your own animals until they can be checked by a veterinarian.</p>
                    </Col>
                </Row>

                <Row className="my-4 bg-light p-4 rounded">
                    <Col md={12}>
                        <h3 className="text-center">Success Stories</h3>
                        <p className="text-center mb-4">Our community has helped reunite thousands of pets with their families</p>
                    </Col>
                    <Col md={4}>
                        <div className="card h-100">
                            <div className="card-body">
                                <h5 className="card-title">Max - Found after 2 weeks</h5>
                                <p className="card-text">"After my indoor cat slipped out during a delivery, I was devastated. Thanks to Pets Home alerts, a neighbor spotted Max just three blocks away! The night search tips were invaluable." - Sarah, California</p>
                            </div>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="card h-100">
                            <div className="card-body">
                                <h5 className="card-title">Bella - Reunited same day</h5>
                                <p className="card-text">"My Golden Retriever bolted during a thunderstorm. Within hours of posting on Pets Home, someone recognized her from the alert and called me! She was found 2 miles from our house." - Michael, Minnesota</p>
                            </div>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="card h-100">
                            <div className="card-body">
                                <h5 className="card-title">Oliver - Home after 3 days</h5>
                                <p className="card-text">"As a stray cat rescuer, I was heartbroken when one of my rescues escaped. The Pets Home community helped spread the word, and Oliver was found hiding in a neighbor's shed!" - Lisa, Texas</p>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row className="my-5">
                    <Col md={12}>
                        <h2 className="text-center">Lost Pet Resources by State</h2>
                        <p>In addition to our platform, we recommend connecting with these resources in your area:</p>
                    </Col>
                    <Col md={4}>
                        <h4>California</h4>
                        <ul>
                            <li>California Animal Control Directory</li>
                            <li>California Found Cats Network</li>
                            <li>Los Angeles Animal Services</li>
                            <li>San Francisco SPCA</li>
                        </ul>
                    </Col>
                    <Col md={4}>
                        <h4>Minnesota</h4>
                        <ul>
                            <li>MN Lost Dog & Cat Rescue</li>
                            <li>Found Cats MN Network</li>
                            <li>Recently Found Pets MN Registry</li>
                            <li>Animal Humane Society (Twin Cities)</li>
                        </ul>
                    </Col>
                    <Col md={4}>
                        <h4>National Resources</h4>
                        <ul>
                            <li>Humane Society Lost and Found Pets Database</li>
                            <li>PetFBI - Lost and Found Pets</li>
                            <li>Missing Animal Response Network</li>
                            <li>Nextdoor Neighborhood Alerts</li>
                        </ul>
                    </Col>
                </Row>

                <Row className="my-5">
                    <Col md={6}>
                        <h3>When To Stop Looking For a Lost Pet?</h3>
                        <p>This is one of the most difficult questions pet owners face. While there's no definitive answer, we encourage persistence. We've documented cases of:</p>
                        <ul>
                            <li>Indoor cats returning home after 30+ days</li>
                            <li>Dogs being found miles from home weeks after going missing</li>
                            <li>Pets being recovered due to microchip scans months after disappearing</li>
                        </ul>
                        <p>As long as you can emotionally manage it, continue checking shelters, refreshing online listings, and following up on possible sightings. Many reunions happen long after owners had nearly given up hope.</p>
                    </Col>
                    <Col md={6}>
                        <h3>Common Search Questions</h3>
                        <div className="accordion" id="faqAccordion">
                            <div className="card">
                                <div className="card-header" id="headingOne">
                                    <h5 className="mb-0">
                                        <button className="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseOne">
                                            What are the chances of finding a lost cat after 24 hours?
                                        </button>
                                    </h5>
                                </div>
                                <div id="collapseOne" className="collapse" data-parent="#faqAccordion">
                                    <div className="card-body">
                                        Research shows that approximately 61% of lost cats are found within the first 24 hours. This percentage increases to 85% within a week. Don't lose hope - continue searching, especially at dawn and dusk.
                                    </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header" id="headingTwo">
                                    <h5 className="mb-0">
                                        <button className="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseTwo">
                                            How do I find a lost cat at night?
                                        </button>
                                    </h5>
                                </div>
                                <div id="collapseTwo" className="collapse" data-parent="#faqAccordion">
                                    <div className="card-body">
                                        Use a flashlight to look for the reflection of their eyes, search during quiet hours (midnight to 4 AM), bring familiar sounds (treat bags, food dishes), and set humane traps with familiar-smelling items.
                                    </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header" id="headingThree">
                                    <h5 className="mb-0">
                                        <button className="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseThree">
                                            Who should I call if I found a lost dog?
                                        </button>
                                    </h5>
                                </div>
                                <div id="collapseThree" className="collapse" data-parent="#faqAccordion">
                                    <div className="card-body">
                                        Contact your local animal control, nearby veterinary offices (to check for microchips), and animal shelters. Post on our app and community sites like Nextdoor and local Facebook groups.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row className="my-5">
                    <Col md={12}>
                        <h2 className="text-center">How Our Lost & Found Platform Works</h2>
                    </Col>
                    <Col md={4} className="text-center">
                        <div className="p-3">
                            <i className="fas fa-file-alt fa-3x mb-3"></i>
                            <h4>Create a Detailed Report</h4>
                            <p>Submit information about your lost or found pet, including multiple photos, distinctive markings, and last-seen location.</p>
                        </div>
                    </Col>
                    <Col md={4} className="text-center">
                        <div className="p-3">
                            <i className="fas fa-map-marked-alt fa-3x mb-3"></i>
                            <h4>Location-Based Alerts</h4>
                            <p>Our system notifies users in the vicinity about lost and found pets, increasing the chances of a quick reunion.</p>
                        </div>
                    </Col>
                    <Col md={4} className="text-center">
                        <div className="p-3">
                            <i className="fas fa-comments fa-3x mb-3"></i>
                            <h4>Secure Communication</h4>
                            <p>Connect directly with potential matches through our secure messaging system to verify details and coordinate reunions.</p>
                        </div>
                    </Col>
                </Row>

                <Row className="my-5">
                    <Col md={12}>
                        <h3 className="text-center mb-4">Popular Searches</h3>
                        <div className="d-flex flex-wrap justify-content-center">
                            <a href="#" className=" m-1 p-2">Lost cat near me</a>
                            <a href="#" className=" m-1 p-2">Dog found near me</a>
                            <a href="#" className=" m-1 p-2">Indoor cat missing</a>
                            <a href="#" className=" m-1 p-2">Lost dog pictures</a>
                            <a href="#" className=" m-1 p-2">Cat found MN</a>
                            <a href="#" className=" m-1 p-2">How to find a lost cat</a>
                            <a href="#" className=" m-1 p-2">Stray cat help</a>
                            <a href="#" className=" m-1 p-2">Report found pet</a>
                            <a href="#" className=" m-1 p-2">Lost pet flyers</a>
                            <a href="#" className=" m-1 p-2">Pet microchip lookup</a>
                            <a href="#" className=" m-1 p-2">California lost pets</a>
                            <a href="#" className=" m-1 p-2">Minnesota humane society</a>
                        </div>
                    </Col>
                </Row>

                <Row className="my-5">
                    <Col md={12} className="text-center">
                        <h3>Download Our App</h3>
                        <p>For faster alerts, real-time notifications, and a more streamlined reporting process, download the Pets Home app today.</p>
                        <p className="font-weight-bold">Join thousands of pet owners who have successfully reunited with their beloved companions!</p>
                    </Col>
                </Row>


            </Container>
        </>
    );
};

export default LostAndFound;
